import React, { useContext, useState } from "react";
import AuthContext from "../../store/AuthContext";
import { Navigate, useLocation } from "react-router-dom";
import { GoogleLogin } from "@react-oauth/google";
import { useMutation } from "@tanstack/react-query";
import { loginUser } from "../../services/userService";

const LoginPage = () => {
  //Checking and redirecting if user is already authenticated
  const { authenticated, logIn, logOut } = useContext(AuthContext);
  const [errMsg, setErrMsg] = useState("");

  // verifying user login in backend
  const mutation = useMutation(loginUser, {
    onSuccess: (res) => {
      logIn(res?.data?.data?.token?.access);
    },
    onError: (error) => {},
    onSettled: (data, error) => {},
  });

  let location = useLocation();
  let { from } = location.state || { from: { pathname: "/" } };

  if (authenticated) {
    // user is not authenticated
    return <Navigate to={from} replace />;
  }

  // Google Login Functionality

  const handleGoogleLogin = (loginData) => {
    const data = { token: loginData.credential };
    loginUser(data)
      .then((res) => {
        if (res?.data?.is_success) {
          logIn(res?.data?.data?.token?.access);
        } else {
          setErrMsg("Some error occurred when trying to login");
        }
      })
      .catch((err) => console.log(err));
  };

  const handleGoogleFailure = (data) => {};

  return (
    <div className="flex flex-col justify-center items-center">
      <GoogleLogin
        //type="standard"
        //text="signin"
        //shape="rectangular"
        //size="large"
        useOneTap={true}
        onSuccess={handleGoogleLogin}
        onError={handleGoogleFailure}
      />
      <div className="mt-4 text-red-500 text-sm">{errMsg}</div>
    </div>
  );
};

export default LoginPage;
